<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">进件管理</div>
        <div class="page-subtitle">商户入驻审核与流程跟进</div>
      </div>
      <el-button type="primary" @click="goCreate">新建进件</el-button>
    </div>
    <el-card>
      <el-table :data="records" stripe>
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="admin_name" label="所属用户" min-width="80" />
        <el-table-column prop="name" label="商户名称" min-width="160" />
        <el-table-column prop="merchantCode" label="商户编码" width="160" />
        <el-table-column prop="enterpriseType" label="企业类型" width="120">
          <template slot-scope="scope">
            {{
              scope.row.enterpriseType === '0' ? '企业'
              : scope.row.enterpriseType === '1' ? ''
              : scope.row.enterpriseType === '2' ? ''
              : scope.row.enterpriseType
            }}
          </template>
        </el-table-column>
        <el-table-column prop="todayReceived" label="今日收款金额" width="120" />
        <el-table-column prop="todayRefunded" label="今日退款金额" width="120" />
        <el-table-column prop="totalReceived" label="累计收款金额" width="120" />
        <el-table-column prop="totalRefunded" label="累计退款金额" width="120" />
        <el-table-column prop="todaySuccessRate" label="今日成功率" width="120" />
        <el-table-column prop="totalSuccessRate" label="累计成功率" width="120" />
        <el-table-column prop="auditStatus" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.auditStatus === '0' ? 'warning'
                : scope.row.auditStatus === '1' ? ''
                : scope.row.auditStatus === '2' ? 'success'
                : scope.row.auditStatus === '3' ? 'danger'
                : scope.row.auditStatus === '4' ? 'info'
                : scope.row.auditStatus === '5' ? 'warning'
                : scope.row.auditStatus === '6' ? 'danger'
                : scope.row.auditStatus === '7' ? 'danger'
                : 'info'
              "
              size="mini"
              effect="plain"
            >
              {{ 
                scope.row.auditStatus === '0' ? '待签署'
                : scope.row.auditStatus === '1' ? '待审核'
                : scope.row.auditStatus === '2' ? '开户成功'
                : scope.row.auditStatus === '3' ? '审核退回'
                : scope.row.auditStatus === '4' ? '人工处理'
                : scope.row.auditStatus === '5' ? '待机审'
                : scope.row.auditStatus === '6' ? '机审拒绝'
                : scope.row.auditStatus === '7' ? '开户失败'
                : scope.row.auditStatus
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="170" />
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; gap: 8px;">
              <!-- 固定显示的按钮 -->
              <el-button type="primary" size="small" icon="el-icon-search" @click="querySubMerchants(scope.row.id)">查询</el-button>
              <el-button type="info" size="small" icon="el-icon-view" @click="viewDetails(scope.row.id)">详情</el-button>
              <el-button type="success" size="small" icon="el-icon-check" v-if="scope.row.auditStatus == '0'" @click="signSubMerchants(scope.row.id)">签署</el-button>
              
              <!-- 折叠菜单 -->
              <el-dropdown trigger="click">
                <el-button type="default" size="small" icon="el-icon-more">更多操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- 子商编操作 -->
                  <el-dropdown-item @click.native="applySubMerchant(scope.row.id)">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-coin" style="margin-right: 4px;"></i>申请支付宝子商编
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="applyWechatSubMerchant(scope.row.id)">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-coin" style="margin-right: 4px;"></i>申请微信子商编
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="viewSubMerchantList(scope.row.id)">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-notebook-2" style="margin-right: 4px;"></i>子商编列表
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="editRemark(scope.row)">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-edit" style="margin-right: 4px;"></i>编辑备注
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isSuperAdmin" @click.native="editOwner(scope.row)">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-user" style="margin-right: 4px;"></i>修改所属用户
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="confirmDeleteMerchant(scope.row)">
                    <span style="display: flex; align-items: center; color: #f56c6c;">
                      <i class="el-icon-delete" style="margin-right: 4px;"></i>删除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
      
    <!-- 测试支付方式选择对话框 -->
    <!-- <el-dialog
      title="选择测试支付方式"
       :visible.sync="paymentDialogVisible"
      width="400px"
    >
      <el-radio-group v-model="selectedPaymentMethod">
        <el-radio label="alipay_order">支付宝H5/APP/小程序跳转支付</el-radio>
        <el-radio label="wechat_order">微信H5/APP/小程序跳转支付</el-radio>
        <el-radio label="aggregate_scan_wechat">微信聚合码扫码支付</el-radio>
        <el-radio label="aggregate_scan_alipay">支付宝聚合码扫码支付</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPaymentTest">确定</el-button>
      </span>
    </el-dialog> -->
    
    <!-- 备注编辑对话框 -->
    <el-dialog
      title="编辑备注"
      :visible.sync="remarkDialogVisible"
      width="500px"
    >
      <el-form label-width="80px">
        <el-form-item label="商户名称">
          <el-input v-model="remarkForm.name" disabled />
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input
            v-model="remarkForm.remark"
            type="textarea"
            placeholder="请输入备注信息"
            :rows="4"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEditRemark">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 删除商户确认对话框 -->
    <el-dialog
      title="删除商户"
      :visible.sync="deleteDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 0;">
        <p>确定要删除商户 <span style="color: #f56c6c;">{{ deleteForm.name }}</span> 吗？</p>
        <p style="margin-top: 10px; color: #999; font-size: 12px;">删除后将无法恢复，请谨慎操作！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">删除</el-button>
      </span>
    </el-dialog>
    
    <!-- 修改所属用户对话框 -->
    <el-dialog
      title="修改所属用户"
      :visible.sync="ownerDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px">
        <el-form-item label="商户名称" required>
          <el-input v-model="ownerForm.name" disabled />
        </el-form-item>
        <el-form-item label="当前所属用户" required>
          <el-input v-model="ownerForm.currentOwner" disabled />
        </el-form-item>
        <el-form-item label="新所属用户" required>
          <el-select v-model="ownerForm.newOwnerId" placeholder="选择用户">
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.username"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ownerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEditOwner">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      records: [],
      // 测试支付相关
      paymentDialogVisible: false,
      selectedPaymentMethod: '',
      currentMerchantCode: '',
      currentUserIdIdentity: '',
      // 备注编辑相关
      remarkDialogVisible: false,
      remarkForm: {
        id: '',
        name: '',
        remark: ''
      },
      // 删除商户相关
      deleteDialogVisible: false,
      deleteForm: {
        id: '',
        name: ''
      },
      // 修改所属用户相关
      ownerDialogVisible: false,
      ownerForm: {
        id: '',
        name: '',
        currentOwner: '',
        newOwnerId: ''
      },
      users: [],
      isSuperAdmin: false
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() { },
  // 页面创建完成
  created() {
    // 初始化拉取商户列表
    this.getMerchants();
    // 检查当前用户是否为超级管理员
    this.checkSuperAdmin();
 
  },
  methods: {
    // 获取商户列表
    getMerchants() {
      this.$http_get("/admin/merchant/list?page=1&limit=20", 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.records = list.map(item => ({
            ...item,
            created_at: this.formatTime(item.created_at)
          }));
        }
      });
    },
    // 格式化时间
    formatTime(value) {
      if (!value) {
        return "";
      }
      const numeric = Number(value);
      const dateValue = Number.isNaN(numeric) ? new Date(value) : new Date(numeric * 1000);
      if (Number.isNaN(dateValue.getTime())) {
        return String(value);
      }
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, "0");
      const day = String(dateValue.getDate()).padStart(2, "0");
      const hour = String(dateValue.getHours()).padStart(2, "0");
      const minute = String(dateValue.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    // 跳转新增进件
    goCreate() {
      this.$router.push("/onboarding/create");
    },
    // 查询子商户
    querySubMerchants(merchantId) {
      this.$http_get(`/admin/merchant/subMerchantQuery?id=${merchantId}`, 1).then(res => {
        if (res && res.code === 200) {
          console.log('子商户查询结果:', res.data);
        } 
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('查询子商户失败:', err);
      });
    },
    // 签署子商户
    signSubMerchants(merchantId) {
      this.$http_get(`/admin/merchant/subMerchantSign?id=${merchantId}`, 1).then(res => {
        if (res && res.code === 200) {
          console.log('子商户签署结果:', res.data);
          // 创建表单并提交到外部接口
          this.submitToExternal(res.data);
        } 
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('签署子商户失败:', err);
      });
    },
    // 提交到外部接口
    submitToExternal(data) {
      const form = document.createElement('form');
      form.action = 'https://open.sumapay.com/open/signProtocolSubMerchant_init';
      form.method = 'post';
      form.target = '_blank';
      
      // 遍历数据创建表单字段
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = data[key];
          form.appendChild(input);
        }
      }
      
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    // 查看详情
    viewDetails(merchantId) {
      this.$router.push(`/onboarding/create?id=${merchantId}`);
    },
    // 测试支付
    testPayment(merchantCode, userIdIdentity) {
      this.currentMerchantCode = merchantCode;
      this.currentUserIdIdentity = userIdIdentity;
      this.selectedPaymentMethod = 'alipay_scan'; // 默认选择支付宝扫码
      this.paymentDialogVisible = true;
    },
    // 确认测试支付
    confirmPaymentTest() {
      if (!this.selectedPaymentMethod) {
        this.$message.warning('请选择支付方式');
        return;
      }
      
      const merchantCode = this.currentMerchantCode;
      const userIdIdentity = this.currentUserIdIdentity;
      const paymentType = this.selectedPaymentMethod;
      
      console.log('测试支付参数:', { merchantCode, userIdIdentity, paymentType });
      this.$http_get(`/admin/merchant/testPayment?merchantCode=${merchantCode}&userIdIdentity=${userIdIdentity}&paymentType=${paymentType}`, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('测试支付请求成功');
          console.log('测试支付结果:', res.data);
        } else {
          this.$message.error(res.msg || '测试支付失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('测试支付失败:', err);
      }).finally(() => {
        this.paymentDialogVisible = false;
      });
    },
    // 子商编申请
    applySubMerchant(merchantId) {
      // 打开新页面跳转到子商编申请页面
      // window.open(`/onboarding/subMerchantApply?id=${merchantId}`, '_blank');
      this.$router.push(`/onboarding/submerchant-apply?id=${merchantId}`);
    },
    // 微信子商编申请
    applyWechatSubMerchant(merchantId) {
      // 打开新页面跳转到微信子商编申请页面
       this.$router.push(`/onboarding/wechat-submerchant-apply?id=${merchantId}`);
    },
    // 子商编列表
    viewSubMerchantList(merchantId) {
      // 跳转到子商编列表页面
      this.$router.push(`/onboarding/submerchant-list?id=${merchantId}`);
    },
    // 打开备注编辑弹窗
    editRemark(row) {
      this.remarkForm.id = row.id;
      this.remarkForm.name = row.name;
      this.remarkForm.remark = row.remark || '';
      this.remarkDialogVisible = true;
    },
    // 确认编辑备注
    confirmEditRemark() {
      if (!this.remarkForm.id) {
        this.$message.warning('参数错误');
        return;
      }
      
      this.$http_post('/admin/merchant/updateRemark', {
        id: this.remarkForm.id,
        remark: this.remarkForm.remark
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('备注修改成功');
          this.remarkDialogVisible = false;
          // 刷新列表
          this.getMerchants();
        } else {
          this.$message.error(res.msg || '备注修改失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('修改备注失败:', err);
      });
    },
    // 打开删除确认对话框
    confirmDeleteMerchant(row) {
      this.deleteForm.id = row.id;
      this.deleteForm.name = row.name;
      this.deleteDialogVisible = true;
    },
    // 确认删除商户
    confirmDelete() {
      if (!this.deleteForm.id) {
        this.$message.warning('参数错误');
        return;
      }
      
      this.$http_post('/admin/merchant/delete', {
        id: this.deleteForm.id
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('删除成功');
          this.deleteDialogVisible = false;
          // 刷新列表
          this.getMerchants();
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('删除商户失败:', err);
      });
    },
    // 检查当前用户是否为超级管理员
    checkSuperAdmin() {
      // 从本地存储或接口获取当前用户信息
      this.$http_get('/admin/account/info').then(res => {
        const isSuper = res && res.data ? res.data.is_super : 0;
        this.isSuperAdmin = Number(isSuper) || 0;
      })
    },
    // 获取用户列表
    getUsers() {
      this.$http_get('/admin/Agent/all?all=1', 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.users = res.data.data || [];
        } else {
          console.error('获取用户列表失败:', res);
        }
      }).catch(err => {
        console.error('获取用户列表失败:', err);
      });
    },
    // 打开修改所属用户对话框
    editOwner(row) {
         // 获取用户列表
      this.getUsers();
      this.ownerForm.id = row.id;
      this.ownerForm.name = row.name;
      this.ownerForm.currentOwner = row.admin_name || '';
      this.ownerForm.newOwnerId = '';
      this.ownerDialogVisible = true;
    },
    // 确认修改所属用户
    confirmEditOwner() {
      if (!this.ownerForm.id || !this.ownerForm.newOwnerId) {
        this.$message.warning('参数错误');
        return;
      }
      
      this.$http_post('/admin/merchant/updateOwner', {
        id: this.ownerForm.id,
        admin_id: this.ownerForm.newOwnerId
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.ownerDialogVisible = false;
          // 刷新列表
          this.getMerchants();
        } else {
          this.$message.error(res.msg || '所属用户修改失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('修改所属用户失败:', err);
      });
    }
  }
};
</script>
